import { ARCHIVE_LOADING } from '../constants'

export default function hideLoader(archive) {
    archive.setAttribute(ARCHIVE_LOADING, 'false')
}